import { useEffect } from 'react';
import { useState } from 'react';
import {
  Modal,
  Button,
  DatePicker,
  Form,
  message,
} from 'antd';
import '../../styles/index.scss';
import moment from 'moment';
import { space } from '../../configs/designTokens';

export const TaskStartDatePickerModal = ({ visible, setVisible, onClose, currentStartDate, disabledDates = true }) => {
  const [isSelecting, setIsSelecting] = useState(false);

  const [form] = Form.useForm();

  const handleDateOk = () => {
    try {
      setVisible(false);
      message.destroy();
      onClose(form.getFieldsValue());
    } catch (error) {
      message.error('Error occurred while validating date:', error);
    }
  };

  useEffect(() => {
    if (currentStartDate) {
      form.setFieldsValue({
        startDate: currentStartDate ? moment(currentStartDate) : null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStartDate]);

  return (
    <>
      <Modal
        closable={false}
        open={visible}
        width={300}
        onCancel={() => setVisible(false)}
        footer={null}
        className="task-date-picker-modal"
        bodyStyle={{ padding: space[0], overflow: 'visible' }}
      >
        <Form
          form={form}
          initialValues={{
            startDate: moment(),
          }}
        >
          <div className="task-date-picker-modal__container">
            <div className="task-date-picker-modal__content">
              <div className="task-date-picker-modal__picker-wrapper">
                <Form.Item name="startDate" noStyle>
                  <DatePicker
                    open={visible}
                    onChange={() => {
                      setIsSelecting(true);
                      setTimeout(() => setIsSelecting(false), 100);
                    }}
                    onOpenChange={(open) => {
                      if (!open && !isSelecting) {
                        setVisible(false);
                      }
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="task-date-picker"
                    disabledDate={disabledDates ? (current) => {
                      const today = moment().startOf('day');
                      return current && current.isBefore(today, 'day');
                    } : null}
                  />
                </Form.Item>
              </div>
              <div
                className="task-date-picker-modal__footer task-date-picker-modal__footer--end"
                onMouseDown={() => setIsSelecting(true)}
                onMouseUp={() => setIsSelecting(false)}
              >
                <Button type="link" onClick={handleDateOk}>
                  Update
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
